<script setup lang="ts">
    import { useResectionHeightViewModel } from '@/views/3d-planner/measurements/useResectionHeightViewModel';

    const vm = useResectionHeightViewModel();
</script>

<template>
    <div v-if="vm.visible" class="measurements" data-testid="resection-height">
        <div class="title">Resection Height</div>
        <div class="group">
            <div class="group-value" :class="{ warning: vm.warning }">
                {{ vm.formattedDistance }}
                <span v-if="vm.warning" class="warning-badge" data-testid="resection-height-warning">
                    <v-icon size="25" color="yellow">mdi-alert</v-icon>
                    <app-tooltip activator="parent" offset="26">
                        <span>
                            Neck cut detected as being less than {{ vm.warningThresholdMm }}mm
                            above the lesser trochanter
                        </span>
                    </app-tooltip>
                </span>
                <div class="group-label">Lesser Trochanter</div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .title {
        font-size: 0.75rem;
        font-weight: 500;
        letter-spacing: 0.1666666667em;
        line-height: 2rem;
        text-transform: uppercase;
        color: rgb(var(--v-theme-white));
        width: 100%;
    }

    .measurements {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 40px;

        .group {
            flex-basis: 50%;
        }
    }

    .group {
        display: flex;
        flex-direction: column;
        flex-basis: 33%;
        margin-bottom: 10px;
    }

    .group-value {
        font-weight: 700;
        font-size: 1rem;
        letter-spacing: 0.009375em;
        line-height: 1.75rem;
        color: rgb(var(--v-theme-white));

        &.warning {
            color: rgb(var(--v-theme-caution));
        }
    }

    .group-label {
        font-size: 0.75rem;
        letter-spacing: 0.0333333333em;
        line-height: 1.25rem;
        color: rgb(var(--v-theme-on-scene-background));
        font-weight: 500;
    }
</style>